import { remove } from 'lodash/fp';

import Message from 'dashboard/lib/interfaces/Message';
import { MessagesActions, MessagesActionType } from 'dashboard/redux/actions/messages';

export interface MessagesState {
  messages: Message[];
}

const initialState: MessagesState = {
  messages: [],
};

export default function (state: MessagesState = initialState, action: MessagesActions) {
  switch (action.type) {
    case MessagesActionType.ShowMessage:
      return {
        messages: [action.payload, ...state.messages],
      };

    case MessagesActionType.ClearMessage:
      return {
        messages: remove((message) => message.id === action.payload.id, state.messages),
      };

    case MessagesActionType.ClearMessages:
      return {
        messages: [],
      };

    case MessagesActionType.ClearMessagesOnRouteChange:
      // Remove all messages without the persist flag, and remove all persist flags
      return {
        messages: state.messages
          .filter((message) => message.persist)
          .map((message) => {
            return { ...message, persist: false };
          }),
      };

    default:
      return state;
  }
}
